import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { MbmProvider } from '@amzn/react-arb-tools';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { DEFAULT_LOCALE_EN_US, TRANSLATION_ROUTE } from 'src/constants/AppConstants';
import arbManifest from '../i18n/translations/arbManifest';
import { AppRouter } from './AppRouter';
import { AppContextProvider } from './context/AppContextProvider';
import { AuthContextProvider } from './context/AuthContextProvider';
import { EventsApiContextProvider } from './context/EventsApiContextProvider';
import { FintechOpsContextProvider } from './context/FintechContextProvider';
import { ErrorFallback } from './generic-components/ErrorFallback';
import { getDocumentTitle } from 'src/utilities/DocumentTitleUtils';

const localizationContext = new LocalizationContextBuilder().withLocale(DEFAULT_LOCALE_EN_US).withDefaultLocale(DEFAULT_LOCALE_EN_US).build();

const mbmOptions = {
  arbManifest,
  defaultLocalizationContext: localizationContext,
  urlPrefix: TRANSLATION_ROUTE
};

export const App: React.FC = () => {
  useEffect(() => {
    document.title = getDocumentTitle();
  }, []);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload();
      }}
    >
      <MbmProvider {...mbmOptions}>
        <AuthContextProvider>
          <AppContextProvider>
            <EventsApiContextProvider>
              <FintechOpsContextProvider>
                <AppRouter />
              </FintechOpsContextProvider>
            </EventsApiContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
      </MbmProvider>
    </ErrorBoundary>
  );
};
